module.exports = __webpack_public_path__ + "img/chartbg.d9267708.png";